import { useFindPassword } from "../authentication/useFindPassword";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/comn/hooks";

const FindPassword = ({ embedded = false, initialUsrId = "" }) => {
    const imgs = { imgLock: `${process.env.PUBLIC_URL}/imgs/img-lock.png` };
    const { theme } = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { findPasswordForm, setFindPasswordForm, handleSubmitFindPassword } = useFindPassword(initialUsrId);
    const { usrId, usrEmlAddr, isLcm } = findPasswordForm;

    return (
        <div className="w-full flex justify-center relative">
            <div className="w-full flex justify-center mt-[70px]">
                <div className={classNames("find-content-min w-full md:w-[520px] lg:w-[520px] h-auto relative")}>
                    <img
                        src={imgs["imgLock"]}
                        width={"700px"}
                        height={"auto"}
                        className="grayscale opacity-10 absolute top-[100px] -left-[300px] -z-[1] hidden md:block lg:block"
                        alt=""
                    />
                    {/*<div className="find-header bg-primary p-[30px] relative rounded-t-[30px]">*/}
                    {/*    <h2 className="text-2xl text-white">{t("L_FIND_PWD")}</h2>*/}
                    {/*    <span className="block w-[214px] lg:w-[214px] absolute -top-[70px] -right-[10px] lg:-right-[70px]">*/}
                    {/*        <img src={imgs["imgLock"]} width={"100%"} height={"auto"} className="" alt="" />*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                    <form
                        className={classNames(
                            "find-body p-[40px] flex flex-col gap-[70px]",
                            embedded ? "pt-[40px]" : "rounded-b-[30px] pt-[70px] bg-card shadow-lg",
                        )}
                        onSubmit={handleSubmitFindPassword}
                    >
                        <div className="find-body-min flex flex-col gap-[14px]">
                            {process.env.REACT_APP_SYSTEM_GROUP == "tanesw" && (
                                <div className="h-12 rounded border border-blue flex items-center px-[16px] gap-[5px] text-blue">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            hidden
                                            className="peer"
                                            type="checkbox"
                                            checked={isLcm}
                                            onChange={(event) =>
                                                setFindPasswordForm((prev) => ({
                                                    ...prev,
                                                    isLcm: event.target.checked,
                                                }))
                                            }
                                        />
                                        <div className="border rounded-full border-blue w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block">
                                            <Icon className="hidden" icon="check" size="xs" />
                                        </div>
                                        License applicants, please select.
                                    </label>
                                </div>
                            )}

                            <p className="flex gap-[5px]">
                                <label htmlFor="username" className="block w-[100px] text-sm pt-[8px]">
                                    ID
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    <input
                                        id="usrId"
                                        type="text"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrId}
                                        onChange={(event) =>
                                            setFindPasswordForm((prev) => ({
                                                ...prev,
                                                usrId: event.target.value.toUpperCase(),
                                            }))
                                        }
                                    />
                                </span>
                            </p>
                            <p className="flex gap-[5px]">
                                <label htmlFor="usernumber" className="block w-[100px] text-sm pt-[8px]">
                                    Email
                                </label>
                                <span className="flex flex-col gap-[4px] w-full">
                                    <input
                                        id="usrEmlAddr"
                                        type="text"
                                        className="text-sm input bg-transparent h-[36px] w-full"
                                        value={usrEmlAddr}
                                        onChange={(event) =>
                                            setFindPasswordForm((prev) => ({ ...prev, usrEmlAddr: event.target.value }))
                                        }
                                    />
                                </span>
                            </p>
                            {/*<p>*/}
                            {/*    <Button*/}
                            {/*        color={theme.isDark == "true" ? "white" : "black"}*/}
                            {/*        variant="underlined"*/}
                            {/*        width="full"*/}
                            {/*        onClick={() => navigate("/findid")}*/}
                            {/*    >*/}
                            {/*        Find ID*/}
                            {/*    </Button>*/}
                            {/*</p>*/}
                        </div>
                        <div className="flex gap-[10px]">
                            <button
                                className={classNames(
                                    "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                    "hover:bg-primary hover:text-white hover:border-primary",
                                )}
                            >
                                {t("L_FIND_PWD")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FindPassword;
